<!--
//================================================================================
// ID:-
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:StepBar
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2023/10/31 | 富士通Japan株式会社    | 新規作成
//================================================================================
-->
<template>
	<div v-if="viewName == 'BC008' && bosyuHoshiki != '3'">
		<div class="step">
			<li v-if="transKbn == '3'" class="is-current">世帯情報変更</li>
			<li v-else class="is-current">世帯情報入力</li>
			<li class="step2 width-step">申込み内容<br>の確認</li>
		</div>
	</div>
	<div v-else-if="viewName == 'BC008' && bosyuHoshiki == '3'">
		<div class="step">
			<li v-if="transKbn == '3'" class="is-currentP step1-current">世帯情報<br class="disp_br">変更</li>
			<li v-else class="is-currentP step1-current">世帯情報<br class="disp_br">入力</li>
			<li class="step2">申込み内容<br>の確認</li>
			<li v-if="transKbn == '3'" class="step3">住宅状況<br>変更</li>
			<li v-else class="step3">住宅状況<br>入力</li>
			<li class="step4">住宅状況<br>入力の確認</li>
		</div>
	</div>
	<div v-else-if="viewName == 'BC009' && bosyuHoshiki != '3'">
		<div class="step">
			<li v-if="transKbn == '3'" class="step1 width-step">世帯情報<br>変更</li>
			<li v-else class="step1 width-step">世帯情報<br>入力</li>
			<li class="is-current">申込み内容の確認</li>
		</div>
	</div>
	<div v-else-if="viewName == 'BC009' && bosyuHoshiki == '3'">
		<div class="step">
			<li v-if="transKbn == '3'" class="step1">世帯情報<br>変更</li>
			<li v-else class="step1">世帯情報<br>入力</li>
			<li class="is-currentP step2-current">申込み内容<br class="disp_br">の確認</li>
			<li v-if="transKbn == '3'" class="step3">住宅状況<br>変更</li>
			<li v-else class="step3">住宅状況<br>入力</li>
			<li class="step4">住宅状況<br>入力の確認</li>
		</div>
	</div>
	<div v-else-if="viewName == 'BC018'">
		<div class="step">
			<li v-if="transKbn == '3'" class="step1">世帯情報<br>変更</li>
			<li v-else class="step1">世帯情報<br>入力</li>
			<li class="step2">申込み内容<br>の確認</li>
			<li v-if="transKbn == '3'" class="is-currentP step3-current">住宅状況<br class="disp_br">変更</li>
			<li v-else class="is-currentP step3-current">住宅状況<br class="disp_br">入力</li>
			<li class="step4">住宅状況<br>入力の確認</li>
		</div>
	</div>
	<div v-else-if="viewName == 'BC019'">
		<div class="step">
			<li v-if="transKbn == '3'" class="step1">世帯情報<br>変更</li>
			<li v-else class="step1">世帯情報<br>入力</li>
			<li class="step2">申込み内容<br>の確認</li>
			<li v-if="transKbn == '3'" class="step3">住宅状況<br>変更</li>
			<li v-else class="step3">住宅状況<br>入力</li>
			<li class="is-currentP step4-current">住宅状況入力<br class="disp_br">の確認</li>
		</div>
	</div>
	<div v-else></div>
</template>

<script>

import { STORE_VIEW_GET_NAME } from '@/const/store.js';

export default {
	inheritAttrs: false,
	props: {
		bosyuHoshiki: {type: String, default: ''},	// 募集方式（1：毎月募集、2：定期募集（抽選方式）、3：定期募集（ポイント方式）、4：随時募集）
		transKbn: {type: String, default: ''},		// 遷移区分（1：募集住宅情報、2：申込み内容の確認または申込み内容確認（一時保存）、3：申込み内容確認（受付済））
	},
	computed: {
		// 画面ID
		viewName: function() {
			return this.$store.getters[STORE_VIEW_GET_NAME];
		}
	},
}
</script>

<style scoped>

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {
	.step {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
		list-style: none;
		margin-top: 75px;
		padding-bottom: 25px;
		width: 100%;
	}
	.step li {
		position: relative;
		padding: 15px 23px;
		margin: 0 25px 10px 0;
		background: grey;
		line-height: 24px;
		font-size: 16px;
	}
	.step li::after {
		content: "";
		position: absolute;
		top: 0;
		right: -30px;
		border-width: 27px 15px;
		border-color: transparent transparent transparent grey ;
		border-style: solid;
	}
	.step li.is-current,
	.step li.is-currentP {
		background: gold;
	}
	.step li.is-current::after,
	.step li.is-currentP::after {
		border-color: transparent transparent transparent gold ;
	}
	.step1,
	.step2,
	.step3,
	.step4 {
		color:white;
		padding: 3px 5px !important;
		text-align: center;
		width: 110px;
	}
	.disp_br {
		display: none;
	}
}

/* 端末がスマホ(横)の場合 */
@media (orientation: landscape)  and (min-width: 601px) {

	.step li::after {
		right: -29.5px !important;
	}
}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {
	.step {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
		list-style: none;
		margin-top: 15px;
		padding-bottom: 5px;
		width: 100%;
	}
	.step li {
		position: relative;
		margin: 0 18px 10px 0;
		background: grey;
		text-align: center;
		font-size: 12px;
		line-height: 16px;
	}
	.step li::after {
		content: "";
		position: absolute;
		top: 0;
		right: -29.7px;
		border-width: 22px 15px;
		border-color: transparent transparent transparent grey ;
		border-style: solid;
	}
	.step li.is-current {
		background: gold;
		padding: 14px 0px 14px 4px !important;
		width: 33% !important;
	}
	.step li.is-current::after {
		border-color: transparent transparent transparent gold ;
	}
	.step li.is-currentP {
		background: gold;
		height: 29px;
	}
	.step li.is-currentP::after {
		border-color: transparent transparent transparent gold ;
	}
	.step1,
	.step2,
	.step3,
	.step4 {
		color:white;
		padding: 5px 0px 10px 0px !important;
		width: 18%;
		height: 29px;
	}
	.step1-current,
	.step3-current {
		width: 16% !important;
		padding: 7px 5px 7px 10px !important;
	}
	.step2-current {
		width: 21% !important;
		padding: 8px 0px 7px 4px !important;
	}
	.step4-current {
		width: 21% !important;
		padding: 7px 0px 7px 4px !important;
	}
	.width-step {
		width: 30% !important;
	}
	.disp_br {
		display: block;
	}
}
</style>